import { Divider, Typography } from '@jisr-hr/ds-beta'
import { GroupListPropsT } from './helper'
import MemoizedListItem from './MemoizedListItem'

const GroupItem = ({ title, list, value, labelKey, valueKey, onChange }: GroupListPropsT) => {
  return (
    <>
      <Divider />
      <div className="cursor-default py-4 px-1.5">
        <Typography
          variant="interface/strong/sm"
          textColor="color/fg/lighter"
          text={title}
        />
      </div>
      {list.map((listItem) => {
        const currentValue = listItem[valueKey ?? 'id']

        const isSelected = String(value) === currentValue
        return (
          <MemoizedListItem
            key={value}
            title={labelKey ? listItem[labelKey] : listItem.name_i18n}
            value={currentValue}
            onClick={() => {
              if (isSelected) {
                onChange({ checked: false, value: '' })
              } else {
                onChange({ checked: true, value: currentValue })
              }
            }}
          />
        )
      })}
      <Divider />
    </>
  )
}

export default GroupItem
